import { Box } from '@mui/material';
import { ChevronRightRounded } from '@mui/icons-material';
import VoiceList from '@src/containers/VoiceLibrary/Content/VoiceList';
import { COLOR } from '@src/styles/color';
import { useHistory } from 'react-router-dom';
import React from 'react';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import route from '@src/constants/route';

const ListVoiceNewest = ({
  voiceList,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  onHandleFavoriteProcessingComplete,
  onErrorProcessingFavouriteVoices,
  onCloseHighlightWeek,
  onChangeVoice,
  onClose,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleSeeAll = () => {
    onCloseHighlightWeek();
    history.push(route.VOICE_LIBRARY, {
      highlightWeek: true,
    });
  };

  return (
    <Box
      style={{ padding: '0px 24px' }}
      className="voice-list-container-result"
    >
      <Box
        className="featured-voice-header"
        style={{
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleSeeAll}
      >
        <Typography variant="body-20-bold" color={COLOR.darkGray}>
          🎉 {t('newestCommunityVoices')}
        </Typography>
        <ChevronRightRounded sx={{ color: COLOR.indigo[80], fontSize: 24 }} />
      </Box>

      <VoiceList
        voices={voiceList}
        isCard={false}
        loadMore={() => {}}
        isTrending
        favouriteVoiceCodes={favouriteVoiceCodes}
        onFavoriteToggleRequest={onFavoriteToggleRequest}
        onHandleFavoriteProcessingComplete={onHandleFavoriteProcessingComplete}
        onErrorProcessingFavouriteVoices={onErrorProcessingFavouriteVoices}
        onChangeVoice={onChangeVoice}
        onClose={onClose}
      />
    </Box>
  );
};

export default ListVoiceNewest;
